import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { ICategory, IItem } from 'safe'
import { ItemType } from '../../common/Inventory/Items'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import CurrencyInput from '../../components/Inputs/CurrencyInput'
import axios from 'axios'
import { getDenomination } from '../../utils/utils'

const Form = React.lazy(() => import('../../components/Form'))
const FormItem = React.lazy(() => import('../../components/Form/FormItem'))
const Button = React.lazy(() => import('../../components/General/Button'))
const InputText = React.lazy(() => import('../../components/Inputs/InputText'))
const InputUpload = React.lazy(
  () => import('../../components/Inputs/InputUpload')
)
const Select = React.lazy(() => import('../../components/Inputs/Select'))
const SelectOfCategories = React.lazy(
  () => import('../../components/Inputs/SelectOfCategories')
)
const InputNumber = React.lazy(
  () => import('../../components/Inputs/InputNumber')
)

const server = process.env.REACT_APP_SERVER_URL

const InventoryForm: React.FC<InventoryFormProps> = ({
  id,
  onSubmit,
  useType = 'create',
  defaultValues,
  categoriesValues,
  onClose,
  categories,
  units,
}) => {
  const ivaType = [
    {
      value: 'GENERAL',
      text: 'General - 16%',
    },
    {
      value: 'REDUCED',
      text: 'Reducido - 8%',
    },
    // {
    //   value: 'SUMPTUARY',
    //   text: 'Suntuario - 15%',
    // },
    {
      value: 'EXEMPT',
      text: 'Exento - 0%',
    },
  ]

  const getIvaType = () => {
    return ivaType.find((d) => d.value === defaultValues?.ivaType)
  }

  const form = useForm<IItem>({
    defaultValues: {
      ...defaultValues,
      price: +defaultValues?.price || 0,
      cost: +defaultValues?.cost || 0,
      ivaType: getIvaType()?.value || defaultValues?.ivaType,
    },
  })
  const [image, setImage] = useState<File>()
  const [subCategories, setSubCategories] = useState<any>([])
  const [currentDefault, setCurrentDefault] = useState<any>(null)
  const [isCompound, setIsCompound] = useState(false)
  const [imageToDelete, setImageToDelete] = useState('')
  const [categoryAlertModal, setCategoryAlertModal] = useState<boolean>(false)

  const currencies = useSelector((state: RootState) => state.curr.currencies)
  const { addAlert } = useSnackBars()

  const [currenciesValues, setCurrenciesValues] = useState<
    { text: string; value: string }[]
  >([])

  const [selectedCurrency, setSelectedCurrency] = useState<any | null>(null)

  // useS

  useEffect(() => {
    let filteredCurrencies = currencies.reduce((a, b: any) => {
      if (b?.id === '1' || b?.id === '2' || b?.id === '3') {
        if (b?.id === '2') {
          return [...a, { text: 'BOLÍVAR (VES)', value: b?.id + '' }]
        } else if (b?.id === '1') {
          return [...a, { text: 'REF (USD)', value: b?.id + '' }]
        } else if (b?.id === '3') {
          return [...a, { text: 'REF (EURO)', value: b?.id + '' }]
        }
      }
      return a
    }, [] as any[])
    setCurrenciesValues(filteredCurrencies)
  }, [currencies])

  const typeOptions = [
    {
      text: 'Materia Prima',
      value: 'RAW_MATERIAL',
    },
    {
      text: 'Productos terminados',
      value: 'FINISHED_PRODUCT',
    },
    // {
    //   text: 'Compuesto',
    //   value: 'COMPOUND',
    // },
    {
      text: 'Mercancia',
      value: 'MERCHANDISE',
    },
    {
      text: 'Suministro indirecto',
      value: 'INDIRECT_SUPPLY',
    },
    {
      text: 'Suministro de oficina',
      value: 'OFFICE_SUPPLY',
    },
    {
      text: 'Otro',
      value: 'OTHER',
    },
    // {
    //   text: 'Producción',
    //   value: 'PRODUCTION',
    // },
  ]

  const [currentType] = useState<any>(typeOptions[2])

  useEffect(() => {
    if (categories?.length === 0) {
      setCategoryAlertModal(true)
    } else {
      setCategoryAlertModal(false)
    }
  }, [categories])

  useEffect(() => {
    setIsCompound(defaultValues?.type === 'COMPOUND')
  }, [defaultValues])

  useEffect(() => {
    setCurrentDefault(
      subCategories?.find(
        (subCategory) => subCategory?.value === defaultValues?.subcategory?.id
      ) || subCategories[0]
    )
  }, [subCategories])

  // const getCategories = (categories: ICategory[]) => {
  //   return categories.map((c) => ({
  //     text: c.name,
  //     value: c.id,
  //     breadcrumb: c.list,
  //     childs: c.children ? getCategories(c.children) : [],
  //   }))
  // }
  // console.log(defaultValues)

  const onSubmitForm = (values): void => {
    console.log('val', values)
    onSubmit({ ...values, imageToDelete })
  }

  const getInfoAccount = async () => {
    let response = await axios.get(`${server}/user/tenant`)
    // setInfoAccount(response?.data?.tenant)
  }

  useEffect(() => {
  getInfoAccount()  
  }, [])

  return (
    <div>
      {/* {categoryAlertModal && (
        <ModalConfirm
          isInfo={true}
          displayConfirmModal={categoryAlertModal}
          title="Debe poseer al menos una categoría registrada antes de agregar productos"
          onCancel={onClose}
          onConfirm={onClose}
          positive={true}
        />
      )} */}
      <Form
        id={id}
        classes="grid grid-cols-12 gap-[40px]"
        form={form}
        onSubmit={(values) =>
          onSubmitForm({ ...values, id: defaultValues?.id, image })
        }
      >
        <div className="col-span-12">
          <h1 className="font-bold text-primary-900 dark:text-gray-400 mb-1">
            {useType === 'create' ? 'Añadir Artículo' : 'Editar Artículo'}
          </h1>
        </div>
        <div className="grid md:col-span-2 col-span-12">
          <InputUpload
            value={defaultValues?.image}
            title="Imagen del artículo"
            fileType="image"
            handleImage={(img) => {
              setImage(img)
            }}
            deleteImage={() => {
              setImageToDelete(defaultValues?.image)
              setImage(undefined)
            }}
            // containerClasses="col-span-12"
            // containerClasses="xl:col-start-1 xl:row-span-3 xl:col-span-3 col-start-3 col-span-8 row-span-8 m-auto"
            imageClasses="rounded-md dark:border-gray-700 w-[300px]"
          />
        </div>

        <div className="grid grid-cols-subgrid-2 gap-6 col-span-10 md:col-span-10 col-span-12">
          <FormItem
            name="name"
            // classes="xl:col-start-1 xl:col-span-7 xl:mb-4 xl:mt-0 col-span-12 row-start-2 mt-5"
            rules={{ required: 'Es necesario un nombre' }}
            classes="md:col-span-6 col-span-2"
          >
            <InputText label="Nombre" />
          </FormItem>

          {/* <div className='flex col-span-2 row-start-2'>
          <h1 className='text-xs'>{selectedCurrency.code}</h1>
        </div> */}

          {/* {useType === 'edit' && (
          <h4
            className={`xl:col-span-4 col-span-12 text-right ${
              getItemType(defaultValues.type).style
            }`}
          >
            {getItemType(defaultValues.type).value}
          </h4>
            )} */}

            { useType === 'create' && (
               <FormItem
               name="type"
               classes="col-span-2 md:col-span-3"
               // classes={`${useType !== 'create' ? 'row-start-3 col-start-10 lg:col-span-12' : 'xl:col-span-4 col-span-4 lg:col-span-12'}`}
               rules={{}}
               defaultValue={currentType}
             >
               {useType === 'create' && (
                 <SelectOfCategories
                   options={typeOptions}
                   setSelectedHelper={(v) => {
                     setIsCompound(v.value === 'COMPOUND')
                   }}
                   label="Tipo"
                 />
               )}
             </FormItem>
            ) }

         

          <FormItem
            name="description"
            classes="col-span-2 md:col-span-3"
            // classes="xl:col-span-5 col-span-12"
            rules={{ required: 'Es necesario una descripción' }}
          >
            <InputText small label="Descripción" />
          </FormItem>

          {!isCompound && (
            <FormItem
              name="brand"
              classes="col-span-2 md:col-span-3"
              // classes="xl:col-span-3 md:col-span-6 col-span-12 flex items-end"
              rules={{}}
            >
              <InputText small label="Marca" />
            </FormItem>
          )}

          {/* {!isCompound && (
          <FormItem
            name="barcode"
            classes="xl:col-span-3 md:col-span-6 col-span-12 xl:flex items-end"
            rules={{
              // required: 'Es necesario un Codigo de Barra',
              pattern: {
                value: /^\d+$/,
                message: 'El código de barras es inválido',
              },
            }}
          >
            <InputText
              small
              label="Código de Barra"
              maxLength={20}
              onCheckIfExist={async () => {
                // console.log("value",  form.getValues().barcode,            )
                // let value = await axios.get(`${server}/inventory/item?evaluate=code&code=${form.getValues().barcode}&pageNumber=1&pageSize=5`)
                // console.log("value", value)
              }}
            />
          </FormItem>
        )} */}

          <FormItem
            name="sku"
            classes="col-span-2 md:col-span-3"
            // classes="xl:col-span-3 md:col-span-6 col-span-12"
            rules={{
              required: 'Es necesario un sku',
              // pattern: {
              //   value: /^\d+$/,
              //   message: 'El sku es inválido',
              // },
            }}
            // rules={{ required: 'Es necesario un SKU' }}
          >
            <InputText small label="Código producto (SKU)" maxLength={16} />
          </FormItem>

          {/* {!watchExcent && (
          <FormItem
            name="tax"
            classes="col-span-3"
            rules={{
              required: 'Es necesario ingresar el valor del impuesto',
              valueAsNumber: true,
            }}
          >
            <InputNumber small min={0} label="Impuesto (%)" />
          </FormItem>
        )} */}

          {/* 
        <div className="">
          <FormItem
            name="category"
            classes="fixed"
            style={{ width: 'calc(0.292 * (100vw - 200px))' }}
            rules={{ required: 'Es necesario una categoria' }}
          >
            <TreeSelect
              label="Categoria"
              options={getCategories(categories)}
              addonAfterOptions={(parent, active) => (
                <AddCategory
                  categories={categories}
                  parent={parent}
                  active={active}
                  onAdd={createCategory}
                />
              )}
            />
          </FormItem>
        </div> */}

          <FormItem
            name="category.id"
            classes="col-span-2 md:col-span-3"
            // classes="xl:col-span-3 col-span-6 flex items-end"
            rules={{}}
            defaultValue={
              categoriesValues?.find(
                (category) => category?.value === defaultValues?.category.id
              ) || null
            }
          >
            {/* <InputText small label="Categoria" maxLength={80} /> */}
            <SelectOfCategories
              options={categoriesValues}
              // is
              // setSelectedHelper={async (v) => {
              //   let response = await axios.get(
              //     `${server}/inventory/subcategory?idCategory=${v.value}&evaluate=SUB_CATEGORY_ALL_EVALUATE`
              //   )
              //   setSubCategories(
              //     response.data.subcategories.map((v) => ({
              //       value: v.id,
              //       text: v.name,
              //     }))
              //   )
              //   // setSubCategories()
              //   // setSubCategories()
              //   // setSubCategories(
              //   //   categories &&
              //   //     categories
              //   //       .find((category) => category?.id === v.value)
              //   //       ?.children.map((sub) => ({ text: sub.name, value: sub.id }))
              //   // )
              // }}
              label="Categoría"
            />
          </FormItem>

          {/* <FormItem
          name="subcategory.id"
          classes="xl:col-span-3 col-span-6"
          rules={{}}
          defaultValue={
            subCategories?.find(
              (category) => category?.value === defaultValues?.subCategory.id
            ) || null
          }
        >
          <SelectOfCategories
            options={subCategories}
            // setSelectedHelper={(v) => {
            //   console.log("V", v)
            //   setIsCompound(true)
            // }}
            label="Sub categoría"
          />
        </FormItem> */}

          {!isCompound && (
            <FormItem
              name="unit"
              classes="col-span-2 md:col-span-3"
              // classes="xl:col-span-3 md:col-span-6 col-span-12 flex items-end"
              defaultValue={units[0]}
            >
              {/* <InputText small label="Unidad de medida" maxLength={80} /> */}
              <Select options={units} label="Unidad de medida" />
            </FormItem>
          )}

          {/* <FormItem name="price" classes="md:col-span-3 xl:col-start-4 col-span-6" rules={{
          pattern: { value: /^\d{1,20}(,\d{2})?$/, message: 'Formato de moneda no válido' },
        }}
        >
          <InputText small label="Precio" maxLength={80} />
        </FormItem> */}

          {/* <FormItem
          name="discount"
          classes="md:col-span-3 col-span-6"
          rules={{
            required: 'Es necesario ingresar el valor del descuento',
            valueAsNumber: true,
            min: { value: 1, message: 'Campo debe de ser mayor de 1' },
            max: { value: 100, message: 'Campo debe de ser menor de 100' },
          }}
        >
          <InputNumber small label="Descuento" />
        </FormItem> */}

          {/* <div className="xl:col-start-1 xl:col-span-3 row-span-2 mt-3 flex flex-col justify-evenly"> */}
          {/* <FormItem
          name="exempt"
          classes="xl:col-span-3 col-span-6 mt-5 row-start-6"
        >
          <Switch small label="Exento de Impuesto" />
        </FormItem> */}

          <FormItem
            name="price"
            classes="col-span-2 md:col-span-3"
            // classes="xl:col-span-3 col-span-6 row-start-8 xl:flex items-end"
            rules={{
              required: 'Es necesario ingresar el precio',
              validate: (value) => {
                if (value === "Bs. 0,00") {
                  return 'El precio debe ser mayor a cero';
                }
                return true;
              }
            }}
          >
            {/* <InputText small label="Precio" maxLength={16} /> */}
            <CurrencyInput
              small
              label="Precio"
              mask={`${getDenomination(selectedCurrency?.id) || 'Bs'} num`}
              addDecimals={true}
              value={defaultValues?.price}
            />
          </FormItem>

          <FormItem
            name="cost"
            classes="col-span-2 md:col-span-3"
            // classes="xl:col-span-3 col-span-6 row-start-8 mt-2"
          >
            {/* <InputText small label="Costo" maxLength={16} /> */}
            <CurrencyInput
              small
              label="Costo"
              mask={`${getDenomination(selectedCurrency?.id) || 'Bs'} num`}
              addDecimals={true}
              value={defaultValues?.cost}
            />
          </FormItem>

          <FormItem
            name="ivaType"
            classes="col-span-2 md:col-span-3"
            // classes="xl:col-span-3 xl:col-start-4 row-start-8 mt-2 lg:col-span-6"
            defaultValue={getIvaType() || ivaType[0]}
          >
            {/* <InputText small label="Precio" maxLength={16} /> */}

            <Select
              options={ivaType}
              label="Tipo de IVA"
              // setSelectedHelper={async (v) => {
              //   setTypeDocumentSelected(v)
              //   let value = await onCheckCb(
              //     useType,
              //     form.getValues().document.document,
              //     v.value,
              //     userConfig.rowsPerPage,
              //     '/thirdparty/provider?',
              //     'providers'
              //   )
              //   if (value) {
              //     form?.setError('document.document', {
              //       type: 'manual',
              //       message: 'Proveedor ya existe',
              //     })
              //   } else {
              //     form?.clearErrors('document.document')
              //   }
              // }}
            />
          </FormItem>

          <FormItem
            name="currency.id"
            classes="col-span-2 md:col-span-3"
            // classes="xl:col-span-3 md:col-span-6 col-span-12 mt-2"
            defaultValue={
              currenciesValues?.find(
                (currency) => currency.value === defaultValues?.currency?.id
              ) || currenciesValues[0]
            }
          >
            {/* <InputText small label="Unidad de medida" maxLength={80} /> */}
            <SelectOfCategories
              options={currenciesValues}
              label={`Moneda`}
              onChange={(values) => {
                console.log('values...', values)
                console.log('currencies...', currencies)
                setSelectedCurrency(
                  currencies.find((currency) => currency.id === values?.value)
                )
              }}
            />
          </FormItem>

          {/* <FormItem
            name="compound"
            classes={`mt-3 ${useType === 'edit' && 'hidden'}`}
          >
            <Switch
              small
              label="Producto Compuesto"
              onChange={(v) => setIsCompound(v)}
            />
          </FormItem> */}
          {/* </div> */}

          {/* { useType === 'create' && (
        <FormItem
          name="subcategory.id"
          classes="xl:col-span-3 md:col-span-3 col-span-6"
          rules={{}}
          defaultValue={typeOptions[0]}
        >
          <SelectOfCategories
            options={typeOptions}
            setSelectedHelper={(v) => {
              console.log("V", v)
              setIsCompound(v.value === 'compound')
            }}
            label="Tipo"
          />
        </FormItem>
        )} */}

          {/* <FormItem
          name="desired_minimum"
          classes="col-span-3 col-star-4"
          rules={{
            required: 'Es necesario agregar un minimo deseado',
            valueAsNumber: true,
          }}
        >
          <InputNumber small label="Minimo deseado" innerProps={{ min: 1 }} />
        </FormItem> */}
          {/* <FormItem
          name="desired_maximum"
          classes="col-span-3"
          rules={{
            required: 'Es necesario agregar un maximo deseado',
            valueAsNumber: true,
          }}
        >
          <InputNumber small label="Maximo deseado" innerProps={{ min: 1 }} />
        </FormItem> */}
          <div className="flex col-span-6 gap-3">
            {onClose && (
              <Button
                type="outline"
                classes="w-1/2"
                onClick={() => onClose()}
                htmlType="button"
              >
                Cancelar
              </Button>
            )}
            <Button type="primary" classes="w-1/2" htmlType="submit">
              {useType === 'create' ? 'Añadir' : 'Guardar cambios'}
            </Button>
          </div>
          {/* TOFIX: comentado hasta que se decida que hacer
        <FormItem name='profit' classes='col-span-2' rules={{ required: 'Es necesario asignar una ganancia', valueAsNumber: true }}>
        <InputNumber small label='Ganancia (%)'/>
      </FormItem> */}
        </div>
      </Form>
    </div>
  )
}

// const mapState = ({ ctgr }: State) => ({ categories: ctgr.categories })
// const connector = connect(null, { createCategory })

export default InventoryForm

// type PropsFromRedux = ConnectedProps<typeof connector>
interface InventoryFormProps {
  onSubmit: Function
  useType?: 'create' | 'edit'
  defaultValues?: object | any
  submitting?: boolean
  id?: string
  onAccept?: Function
  onClose: Function
  categoriesValues: any[]
  categories?: ICategory[]
  units: { text: string; value: string }[]
}

export interface IInvetoryForm {
  id?: string
  image?: string | Blob
  unit: string
  barcode: string | null
  sku: string | null
  brand: string
  category: { id: string }
  description: string
  exempt: boolean
  imageToDelete: {
    id: string
    url: string
  }
  name: string
  subcategory: { id: string }
  type: ItemType
  price: string
  cost: string
  currency: { id: string }
  ivaType?: string
}
